import React from 'react';
import './shapes-decorative-border.scss';

export default function ShapesDecorativeBorder({ children, modalMode = false }) {
  return (
    <>
      <div className={`ShapesDecorativeBorder is-full-screen ${modalMode ? 'modal-mode' : ''}`}>
        <div className="top">
          {modalMode ? (
            <>
              <div className="teal-hoop-top-modal-mode" />
              <div className="white-star-modal-mode" />
            </>
          ) : (
            <div className="teal-hoop-top" />
          )}
        </div>

        <div className="columns is-gapless is-centered middle">
          <div className="column is-hidden-touch">
            {modalMode ? (
              <div className="red-star-left-modal-mode" />
            ) : (
              <>
                <div className="white-star-large" />
                <div className="red-star-top" />
                <div className="red-star-middle" />
                <div className="teal-hoop-bottom" />
                <div className="red-star-bottom" />
              </>
            )}
          </div>

          <div className="column is-narrow">{children}</div>

          <div className="column is-hidden-touch">
            {!modalMode && (
              <>
                <div className="yellow-star" />
                <div className="white-star-small" />
              </>
            )}
          </div>
        </div>

        <div className="bottom">{modalMode && <div className="red-star-bottom-modal-mode" />}</div>
      </div>
    </>
  );
}
